module.exports = __webpack_public_path__ + "img/avantor.55b99d1c.jpeg";